var ReactRedux = require('react-redux');

var actions = require('../../_actions.js');
var Button = require('../../components/Button.jsx');
const constants = require('../../constants/deployment.js');

function isDisabled(state) {
	if (state.git.is_fetching || state.git.is_updating || state.plan.is_loading) {
		return true;
	}
	const current = state.deployment.list[state.deployment.current_id] || {};
	if (constants.isSubmitted(current.state)) {
		return true;
	}
	if (constants.isApproved(current.state)) {
		return true;
	}
	if (constants.isRejected(current.state)) {
		return true;
	}
	if (constants.isQueued(current.state)) {
		return true;
	}
	return false;
}

function interpretError(error) {
	if (!error) {
		return;
	}

	if (error.indexOf('Another fetch is in progress') > -1) {
		return 'Another fetch is in progress, please wait a moment and try again';
	}

	if (error.indexOf('could not read Username for') > -1 || error.indexOf('Repository not found') > -1) {
		return 'Unable to find repo, check if the link is HTTP where it should be SSH or if the repo is private';
	}

	if (error.indexOf('Permission denied') > -1) {
		return 'Access denied, the deploy key from the overview page may need to be added to the repo';
	}

	// SSH keyscan required
	if (error.indexOf('Host key verification failed') > -1) {
		return 'Unable to make SSH connection to repo - contact support';
	}

	return error;
}

const mapStateToProps = function(state) {
	let btnValue = (state.git.is_fetching || state.git.is_updating) ? 'Fetching code...' : 'Fetch code';
	const icon = (state.git.is_fetching || state.git.is_updating) ? 'fa fa-refresh fa-spin' : 'fa fa-refresh';
	if (state.git.error) {
		btnValue = 'Fetch failed - retry?';
	}

	return {
		disabled: isDisabled(state),
		icon: icon,
		style: 'btn btn-default pull-right',
		value: btnValue,
		error: interpretError(state.git.error)
	};
};

const mapDispatchToProps = function(dispatch) {
	return {
		onClick: function() {
			dispatch(actions.updateRepoAndGetRevisions());
		}
	};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Button);
